import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RaiseCreditScoreBeforeMortgage from "@/pages/tools/RaiseCreditScoreBeforeMortgage";

export const Route = createFileRoute("/tools/raise-credit-score-before-mortgage")({
  head: () => seoHead("/tools/raise-credit-score-before-mortgage"),
  component: RaiseCreditScoreBeforeMortgage,
});
